import { useEffect } from 'react';

/**
 * Preloader Component
 * 
 * This component preloads critical assets like images to improve
 * the first content load experience.
 */
const Preloader = () => {
  useEffect(() => {
    // List of critical assets to preload
    const criticalAssets = [
      '/images/logo.png',
      '/uk-flag.svg',
      '/ukraine-flag.svg'
    ];

    // Preload images
    criticalAssets.forEach(src => {
      const img = new Image();
      img.src = src;
    });

    // Preload fonts if needed
    // const fontPreloadLink = document.createElement('link');
    // fontPreloadLink.rel = 'preload';
    // fontPreloadLink.as = 'font';
    // fontPreloadLink.href = '/fonts/your-font.woff2';
    // fontPreloadLink.type = 'font/woff2';
    // fontPreloadLink.crossOrigin = 'anonymous';
    // document.head.appendChild(fontPreloadLink);

  }, []);

  // This component doesn't render anything
  return null;
};

export default Preloader;
